var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"mdc-fab mdc-fab--mini mdc-fab--touch",on:{"click":function($event){return _vm.onClick()}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }